import {getFeatures} from "../../api/mainpage/features";
// import {getNew} from "../../api/news";

const state = () => ({
  feature : {
    imgPath: '',
    title:'',
    text:'',
    buttonText:'',
    buttonLink:''
  },
  features:{
    title:'',
    videoPath:null,
    text:'',
    id:0,
  },
  newsId: null
})


const getters = {
  get_features(state) {
    return state.features;
  },
}

const mutations = {
  SET_FEATURES(state,data){
    state.features = data;}
}

const actions = {
  async fetchFeatures({ commit }) {
    try {
      const response = await getFeatures();
      commit('SET_FEATURES', response.data.results);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
